import styled from 'styled-components'

export const ProfileSettingSection = styled.div``
